import type Quill from 'quill/core';
import { getRangeSaver } from '../../editor/RangeSaver';
import getRangeBoundaries from '../../editor/utils/getRangeBoundaries';
import getContentRectForBoundaries from './getContentRectForBoundaries';

const getContentRectForCurrentSelection = (quill: Quill) => {
  const boundaries = getRangeBoundaries(quill, getRangeSaver(quill).getLast());
  if (!boundaries?.length) return null;

  return getContentRectForBoundaries(boundaries);
};

export default getContentRectForCurrentSelection;
